export enum ComponentTypesEnum {
  Text,
  Select,
  RadioGroup,
  Checkbox,
  Autocomplete,
  PhoneAutocomplete,
  Datepicker,
  CountryAutocomplete,
  LockableDatepicker,
  AddNewSelect,
  Password,
  AmountInput,
  MultipleSelect,
  PhoneOtp,
}
